import './security-status-badge.scss';

import { SecurityStatus, SecurityStatusLabels } from '@/constants';
import { isSecurityStatus } from '@/services';

interface IProps {
  statusCode: string | number | null | undefined;
  withoutLabel?: boolean;
}

const SecurityStatusBadge: React.FC<IProps> = ({
  statusCode,
  withoutLabel = false
}) => {
  if (statusCode && !isSecurityStatus(statusCode)) return null;
  const computedStatusCode = statusCode || SecurityStatus.notVerified;
  if (!isSecurityStatus(computedStatusCode)) return null;
  return (
    <div className="security-status-badge">
      <div
        className={`security-status-badge__badge security-status-badge__badge--${computedStatusCode}`}
      ></div>
      {!withoutLabel && <span>{SecurityStatusLabels[computedStatusCode]}</span>}
    </div>
  );
};

export default SecurityStatusBadge;
